import useFetch from "../../hooks/useFetch";
import { SalesBreakdownModel } from "../../interfaces/endpoints/IAnalytics.types";
import {
  getPeriodAnalytics,
  getTodayAnalytics
} from "../../services/Analytics.service";
import DashboardCard, { rateOf } from "./DashboardCard";

// The rows under a card: what its sales are made of. Ticket fares and the service fee always show; the
// add-ons only when the period has some, so a quiet "today" stays short. The rows add up to the card.
const breakdownRows = (b?: SalesBreakdownModel) => {
  if (!b) return undefined;
  const rows = [
    { label: "Biletat", value: b.fares, always: true },
    { label: "Tarifa e shërbimit", value: b.serviceFee, always: true },
    { label: "Zbritja", value: -b.promotionCodeDiscount, always: false },
    { label: "Travel Flex", value: b.flexiRide, always: false },
    { label: "Open return", value: b.openReturn, always: false },
    { label: "SMS", value: b.textMeMyTrip, always: false },
    { label: "Valixhe", value: b.luggageStorage, always: false }
  ];
  return rows
    .filter((r) => r.always || r.value !== 0)
    .map(({ label, value }) => ({ label, value }));
};

// "Sot" and the 7/30-day cards come from separate requests, each with its own loading state, so
// today's figure shows as soon as it is ready instead of waiting on the longer periods.
const StaticAnalytics = () => {
  const today = useFetch(getTodayAnalytics, { initRequest: true });
  const periods = useFetch(getPeriodAnalytics, { initRequest: true });

  return (
    <div className="flex w-full justify-between lg:flex-row flex-col">
      <DashboardCard
        title="Sot"
        delay={50}
        currentValue={today.response?.data.todaySales?.currentValue || "0"}
        ratePercentage={rateOf(today.response?.data.todaySales)}
        ratePercentageDesc="prej të njejtës ditë të javës së kaluar"
        loading={today.loading}
        breakdown={breakdownRows(today.response?.data.todayBreakdown)}
      />
      <DashboardCard
        delay={150}
        className="lg:mx-2.5 my-2.5 lg:my-0"
        title="7 ditë"
        currentValue={periods.response?.data.lastWeekSales?.currentValue || "0"}
        ratePercentage={rateOf(periods.response?.data.lastWeekSales)}
        ratePercentageDesc="prej periudhës 7 ditore të kaluar"
        loading={periods.loading}
        breakdown={breakdownRows(periods.response?.data.lastWeekBreakdown)}
      />
      <DashboardCard
        title="30 ditë"
        delay={250}
        currentValue={periods.response?.data.currentMonthSales?.currentValue || "0"}
        ratePercentage={rateOf(periods.response?.data.currentMonthSales)}
        ratePercentageDesc="prej periudhës 30 ditore të kaluar"
        loading={periods.loading}
        breakdown={breakdownRows(periods.response?.data.currentMonthBreakdown)}
      />
    </div>
  );
};

export default StaticAnalytics;
